import { DateTimeInput } from './DateTimeInput';

// Date-only field (value "yyyy-MM-dd", shown as "dd-MM-yyyy").
// Thin wrapper over the shared DateTimeInput picker.

interface Props {
  value: string; // yyyy-MM-dd
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  inputClassName?: string;
  disabled?: boolean;
  min?: string;
  max?: string;
}

export function DateInput(props: Props) {
  return <DateTimeInput mode="date" {...props} />;
}
